import React, { FC } from 'react';
import { CardContext } from 'types/Common';
import { StandardCover } from 'types/Cover';
import { CardCircle } from 'components/Cards/CardCircle';
import { CardPortrait } from 'components/Cards/CardPortrait';
import { CardGrid } from './CardGrid';
import { CardStripe } from './CardStripe';
import { CardVariant } from './cardVariants';
import { useStripeCardVariant } from './StripeCardVariantContext';

export type CardProps = {
    variant: CardVariant;
    context: CardContext;
    asset: StandardCover;
    showDescription?: boolean;
    assetType?: string;
};

export const Card: FC<CardProps> = ({ variant, context, asset, showDescription, assetType, ...rest }) => {
    const stripeVariant = useStripeCardVariant();

    if (variant === CardVariant.CIRCLE) {
        return <CardCircle asset={asset} {...rest} />;
    }

    if (context === CardContext.COLLECTION) {
        return variant === CardVariant.PORTRAIT ? (
            <CardGrid variant={variant} asset={asset} withTileFocusOutline {...rest} />
        ) : (
            <CardGrid variant={variant} asset={asset} gridTestId={'tv-collectionitem'} {...rest} />
        );
    }

    if (variant === CardVariant.PORTRAIT) {
        return <CardPortrait asset={asset} {...rest} />;
    }

    return (
        <CardStripe variant={stripeVariant ?? variant} asset={asset} showDescription={showDescription} assetType={assetType} {...rest} />
    );
};
